module.exports = __webpack_public_path__ + "static/img/product_02.4aa0e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/product_02.png
// module id = ckTM
// module chunks = 0